import s from './information.module.scss'
import { PageTemplate } from '@shared/ui/page-template'
import { LegalDocumentsLinks } from '@shared/ui/legal-documents-links/legal-documents-links';
import { NavLink } from 'react-router-dom';
import { IconChevronLeft } from '@tabler/icons-react';

export const Information = () => {
	return (
		<PageTemplate title='Информация' hideTitleOnTablet>
			<NavLink to="/settings" className={s.back}>
				<IconChevronLeft size={16} />
				Назад
			</NavLink>
			<div className={s.card}>
				<div className={s.infoBlock}>
					<div className={s.infoTitle}>
						ДОКУМЕНТЫ
					</div>
					<div className={s.documents}>
						<LegalDocumentsLinks/>
						<a href={process.env.REACT_APP_STORAGE_URL + 'contract.pdf'} rel="noreferrer" target='_blank' download={true}>Договор с преподавателем</a>
					</div>
				</div>
				<div className={s.infoFlex}>
					<div className={s.infoBlock}>
						<div className={s.infoTitle}>
							СВЯЖИСЬ С НАМИ
						</div>
						<div className={s.info}>
							<div className={s.desc}>
							Мы рады новым сотрудничествам и готовы услышать идеи по улучшению нашего продукта.
							</div>
							<div className={s.links}><a href="mailto:contact@sozvuchno.ru">contact@sozvuchno.ru</a></div>
						</div>
					</div>
					<div className={s.infoBlock}>
						<div className={s.infoTitle}>
							СЛЕДИ ЗА НАМИ
						</div>
						<div className={s.info}>
							<div className={s.desc}>
							Следи за обновлениями и последними новостями в наших социальных сетях.
							</div>
							<div className={s.links}>
								<a target='_blank' href="https://t.me/sozvuchno_ed" rel="noreferrer">Telegram</a>
								{/* <a href="">YouTube</a> */}
								<a target='_blank' href="https://vk.com/sozvuchno_music" rel="noreferrer">Vk</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</PageTemplate>
	)
}
